import { Button, Flex, Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getCommunityList } from '../../api/community.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/sales.module.scss'

const CommunityListPage = () => {
  const navigate = useNavigate()
  const [communityList, setCommunityList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalElements, setTotalElements] = useState(0)

  const fetchCommunityList = async (page = 0, size = 10) => {
    setIsLoading(true)
    try {
      const res = await getCommunityList(page, size)
      setCommunityList(res.content || [])
      setTotalElements(res.totalElements || 0)
    } catch (error) {
      console.error('getCommunityList error', error)
      setCommunityList([])
      setTotalElements(0)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchCommunityList(page, pageSize)
    // eslint-disable-next-line
  }, [page, pageSize])

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 70,
      align: 'center',
    },
    {
      title: '카테고리',
      dataIndex: 'categoryName',
      key: 'categoryName',
      width: 200,
      align: 'center',
    },
    {
      title: '게시글',
      dataIndex: 'content',
      key: 'content',
      width: 400,
      render: (text) => (
        <span style={{ fontSize: 12 }}>
          {typeof text === 'string' && text.length > 120
            ? `${text.slice(0, 120)}...`
            : text || '-'}
        </span>
      ),
    },
    // {
    //   title: '조회수',
    //   dataIndex: 'viewNum',
    //   key: 'viewNum',
    //   width: 100,
    //   align: 'center',
    // },
    {
      title: '등록일',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 160,
      align: 'center',
      render: (date) => <span style={{ fontSize: 12 }}>{date}</span>,
    },
    {
      title: '수정일',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      width: 160,
      align: 'center',
      render: (date) => <span style={{ fontSize: 12 }}>{date}</span>,
    },
    {
      title: '댓글 관리',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      align: 'center',
      render: (id) => (
        <Button
          type="link"
          onClick={() => navigate(`/community/comment/${id}`)}
        >
          댓글관리
        </Button>
      ),
    },
    {
      title: '정보 수정',
      dataIndex: 'id',
      key: 'id',
      width: 100,
      align: 'center',
      render: (id, record) => (
        <Button
          type="link"
          onClick={() =>
            navigate(`/community/update/${record.categoryId}/${id}`)
          }
        >
          수정
        </Button>
      ),
    },
  ]

  return (
    <>
      <ContentHeader title="체험단 커뮤니티 관리" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        <Flex
          justify="space-between"
          align="center"
          style={{
            background: '#f8fafd',
            borderRadius: 10,
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            padding: '18px 24px',
            marginTop: 24,
            marginBottom: 18,
            gap: 16,
          }}
        >
          {/* <div style={{ display: 'flex', gap: 16 }} /> */}
          <span style={{ fontWeight: 600, fontSize: 18, color: '#1677ff' }}>
            총{' '}
            <span style={{ fontWeight: 'bold', fontSize: 22 }}>
              {totalElements}
            </span>{' '}
            건
          </span>
        </Flex>

        <Row
          className={`${styles['product-register-border-box']}`}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={`${styles['product-register-box-title']}`}>
            체험단 커뮤니티 목록
          </span>
        </Row>

        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            dataSource={communityList}
            rowKey="id"
            columns={columns}
            loading={isLoading}
            pagination={{
              current: page + 1,
              pageSize: pageSize,
              total: totalElements,
              onChange: (p, ps) => {
                setPage(p - 1)
                setPageSize(ps)
              },
              showSizeChanger: true,
            }}
            bordered
          />
        </div>
      </div>
    </>
  )
}

export default CommunityListPage
